
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLightIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.624 0c4.167 0 7.623 3.548 7.649 7.904 0 2.635-1.27 4.93-3.05 6.261v1.957c0 .548-.457.991-.99 1.043l-6.99.574h-.1c-.255 0-.534-.104-.712-.287-.204-.182-.382-.47-.382-.756v-2.557C5.016 12.704 4 10.565 4 7.904 4 3.548 7.456 0 11.624 0zm0 2.087c-3.075 0-5.591 2.609-5.566 5.817 0 2.14.814 3.705 2.567 4.748.305.209.457.548.457.913v2.009l5.083-.417v-1.592c0-.365.178-.73.508-.913 1.601-.887 2.516-2.66 2.541-4.748 0-3.208-2.515-5.817-5.59-5.817z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15.156 20.504-6.938.522h-.076c-.533 0-.965-.417-1.016-.965a1.04 1.04 0 0 1 .94-1.122l6.937-.522a1.002 1.002 0 0 1 1.093.966 1.04 1.04 0 0 1-.94 1.121zm-2.211 3.287-2.49.209h-.077c-.533 0-.965-.417-1.016-.965a1.04 1.04 0 0 1 .94-1.122l2.516-.209a1.01 1.01 0 0 1 1.067.966 1.04 1.04 0 0 1-.94 1.121zm2.719-15.913c-.05.47-.432.835-.89.835H14.7a.9.9 0 0 1-.788-.991c.152-1.487-1.118-2.035-1.27-2.087a.949.949 0 0 1-.535-1.174c.153-.47.661-.73 1.119-.548.94.34 2.668 1.617 2.44 3.965z",
  fill: "var(--theme-primary, #810ea9)"
}))));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g fill-rule=\"nonzero\" fill=\"none\">\r\n        <path d=\"M11.624 0c4.167 0 7.623 3.548 7.649 7.904 0 2.635-1.27 4.93-3.05 6.261v1.957c0 .548-.457.991-.99 1.043l-6.99.574h-.1c-.255 0-.534-.104-.712-.287-.204-.182-.382-.47-.382-.756v-2.557C5.016 12.704 4 10.565 4 7.904 4 3.548 7.456 0 11.624 0zm0 2.087c-3.075 0-5.591 2.609-5.566 5.817 0 2.14.814 3.705 2.567 4.748.305.209.457.548.457.913v2.009l5.083-.417v-1.592c0-.365.178-.73.508-.913 1.601-.887 2.516-2.66 2.541-4.748 0-3.208-2.515-5.817-5.59-5.817z\" fill=\"#000\"/>\r\n        <path d=\"m15.156 20.504-6.938.522h-.076c-.533 0-.965-.417-1.016-.965a1.04 1.04 0 0 1 .94-1.122l6.937-.522a1.002 1.002 0 0 1 1.093.966 1.04 1.04 0 0 1-.94 1.121zM12.945 23.791l-2.49.209h-.077c-.533 0-.965-.417-1.016-.965a1.04 1.04 0 0 1 .94-1.122l2.516-.209a1.01 1.01 0 0 1 1.067.966 1.04 1.04 0 0 1-.94 1.121zM15.664 7.878c-.05.47-.432.835-.89.835H14.7a.9.9 0 0 1-.788-.991c.152-1.487-1.118-2.035-1.27-2.087a.949.949 0 0 1-.535-1.174c.153-.47.661-.73 1.119-.548.94.34 2.668 1.617 2.44 3.965z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/lightIcon.4b233ec5a652867e105aa910f90f1b31.svg"),
        {
          React: SvgLightIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      